import { Switch } from "@headlessui/react";
import SubHeading from "../../atoms/SubHeading";
import InputField from "../../atoms/InputField";

const HipotecaSection = ({ values, setFieldValue, setArchivosHipoteca }) => {
    const hipotecaFiles = [
        { name: "compra_venta", label: "Contrato de compra-venta" },
        { name: "amortizacion", label: "Tabla de amortización" },
        { name: "seguro_mortgage", label: "Seguro de hipoteca" },
    ];

    return (
        <div className="w-full flex flex-col border border-gray-500 bg-gray-100 p-4 rounded-md">
            <div className="w-full flex flex-row justify-between">
                <SubHeading text="Hipoteca" color="black" />
                <Switch
                    checked={values.isMortgaged}
                    onChange={(value) => setFieldValue("isMortgaged", value)}
                    className={`${values.isMortgaged ? 'bg-rs-azul' : 'bg-gray-500'} relative inline-flex h-6 w-11 items-center rounded-full transition`}
                >
                    <span className={`${values.isMortgaged ? 'translate-x-6' : 'translate-x-1'} inline-block h-4 w-4 transform rounded-full bg-white transition`} />
                </Switch>
            </div>
            {values.isMortgaged && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <InputField name="titular_hipoteca" label="Titular de la hipoteca" placeholder="Titular de la hipoteca"/>
                    <InputField name="banco" label="Banco" placeholder="Banco" />
                    <InputField name="pago_mensual" label="Pago mensual de hipoteca" type="number" placeholder="$"/>
                    <InputField name="start_date" label="Fecha de inicio de la Hipoteca" type="date" />
                    <InputField name="end_date" label="Fecha de fin de la Hipoteca" type="date" />
                    {hipotecaFiles.map(({name, label}) => (
                        <InputField
                            name={name}
                            label={label}
                            type="file"
                            onChange={(e) => {
                                const file = e.currentTarget.files?.[0] || null;
                                setFieldValue(name, file);
                                setArchivosHipoteca((prev) => ({ ...prev, [name]: file }));
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default HipotecaSection;